import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChangableComponent } from '@app/models/changable.component';
import { LibraryRouter } from '@app/models/library.router';
import { CLibraryFilterData } from '@app/store/models';
import { AccountService, ContentService, ContextService, UserServicesService } from '@core/services';
import { BFF_ROUTES, BffService, IBffDefResponse } from '@core/services';
import { Store } from '@ngrx/store';
import { EContentModeType, IContentPane } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { first, takeUntil, tap } from 'rxjs/operators';

/*
 */
@Component({
  selector: 'app-filter-cleaning',
  templateUrl: './filter-cleaning.component.html',
  styleUrls: ['./filter-cleaning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterCleaningComponent extends ChangableComponent implements OnInit {
  protected contextService = inject(ContextService);
  protected contentService = inject(ContentService);
  protected accountService = inject(AccountService);
  protected userServices = inject(UserServicesService);
  deviceService = inject(DeviceDetectorService);
  protected location = inject(Location);
  protected readonly store = inject(Store);
  private router: Router = inject(Router);
  private bffService = inject(BffService);

  private _TAG: string = `[-COMP] ${this.constructor.name}:`;
  @Input() public filterData: CLibraryFilterData;

  public additionalPanes: IContentPane[] = [];

  private _libraryRouteData: CLibraryFilterData;
  private libRouter: LibraryRouter = new LibraryRouter();
  public contentFilter: CLibraryFilterData;

  public debug$ = this.contextService.debug$;
  public debugInfo = '';

  public ngOnInit(): void {
    this.initSubscribe();
  }

  public onCleanAllFilters() {
    this.libRouter.setBaseRoute(this._libraryRouteData.baseRoute);
    this.libRouter.setSubjects([]);
    this.libRouter.setTerm(null);
    sessionStorage.removeItem('selectedSubject');
    this.onApplyFilter();
  }

  public onApplyFilter() {
    const link = this.libRouter.getLink();
    this.router.navigate([link.path], { queryParams: link.parameters }).then();
  }

  public trackByFn(item: IContentPane) {
    return item.order;
  }

  private initSubscribe() {
    this.contentFilter = {
      ...this.filterData,
      term: '',
      contentMode: EContentModeType['not-found'],
      subjectCodes: [],
      subjectsMap: [],
      contentTypeCodes: [],
    };
    this._libraryRouteData = this.filterData;
    this.loadContentBlocks();
  }

  private loadContentBlocks() {
    this.contentService
      .getFeaturings(this.contentFilter)
      .pipe(first(), takeUntil(this.destroyed$))
      .subscribe({
        next: (res) => {
          this.additionalPanes = Array.isArray(res?.data) ? res.data : [];
          this.debugInfo = res.meta.context?.debugInfo;
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
          this.additionalPanes = [];
          this.detectChanges();
        },
      });
  }
}
